export default "__VITE_ASSET__D0C7hQNg__"